export const parseMoney = (value?: string | null) => {
  if (value) return `$${parseInt(value).toLocaleString()}`
  return value
}

export const ESTIMATION_METHODS = {
  averageNetPrice: 'AverageNetCost',
  incomeBasedPrice: 'IncomeBasedPrice',
  customPrice: 'CustomPrice',
  manualEntry: 'ManualEntry',
}
export const ESTIMATION_METHOD_LABELS = {
  AverageNetCost: 'Average Net Price',
  IncomeBasedPrice: 'Income-based Net Price',
  CustomPrice: 'Custom Net Price',
  ManualEntry: 'Custom Net Price',
}
export const STICKER_TYPES = {
  inState: 'InState',
  outState: 'OutState',
  inAndOutState: 'InAndOutOfState',
}
type INCOME_RANGES =
  | 'NetPriceForIncomeFive'
  | 'NetPriceForIncomeFour'
  | 'NetPriceForIncomeOne'
  | 'NetPriceForIncomeThree'
  | 'NetPriceForIncomeTwo'

export type College = {
  Name: string
  Size: number
  GeneralInfo: {
    FtDegree3: number
  }
  CalculatedFields: {
    AcceptanceRate: number
  }
  Selectivity: number
  State: string
  InStateSticker?: number
  OutStateSticker?: number
  AverageNetPrice?: number
  NetPrice?: {
    NetAverage?: number
  }
  CustomNetPrice?: number
  NetPriceForIncomeFive?: number
  NetPriceForIncomeFour?: number
  NetPriceForIncomeOne?: number
  NetPriceForIncomeThree?: number
  NetPriceForIncomeTwo?: number
}
const formatCost = (value: number | string) => parseMoney(value.toString())

const getLabel = (estimationMethod: keyof typeof ESTIMATION_METHOD_LABELS) => ESTIMATION_METHOD_LABELS[estimationMethod]

const getCost = (estimationMethod = ESTIMATION_METHODS.averageNetPrice, parentIncomeRange = '', college: College) => {
  let cost = college.AverageNetPrice || college.NetPrice?.NetAverage
  if (estimationMethod === ESTIMATION_METHODS.customPrice || estimationMethod === ESTIMATION_METHODS.manualEntry) {
    cost = college.CustomNetPrice
  } else if (estimationMethod === ESTIMATION_METHODS.incomeBasedPrice) {
    cost = college[parentIncomeRange as INCOME_RANGES]
  }
  return [estimationMethod, cost]
}

const getFormattedCost = (
  estimationMethod: string | undefined,
  parentIncomeRange: string | undefined,
  college: College,
) => {
  const [method, cost] = getCost(estimationMethod, parentIncomeRange, college)
  const formattedCost = cost ? formatCost(cost) : undefined
  return [method, formattedCost]
}

const getSticker = (parentState: string, college: College) => {
  const { InStateSticker, OutStateSticker, State } = college
  let stickerPriceType
  let stickerPrice
  if (InStateSticker === OutStateSticker) {
    stickerPriceType = STICKER_TYPES.inAndOutState
    stickerPrice = OutStateSticker
  } else {
    stickerPriceType = STICKER_TYPES.outState
    stickerPrice = OutStateSticker
    if (parentState === State) {
      stickerPriceType = STICKER_TYPES.inState
      stickerPrice = InStateSticker
    }
  }
  return [stickerPriceType, stickerPrice]
}
const getFormattedStickerPrice = (parentState: string, college: College) => {
  const [stickerPriceType, stickerPrice] = getSticker(parentState, college)
  const formattedPrice = stickerPrice ? formatCost(stickerPrice) : undefined
  return [stickerPriceType, formattedPrice]
}

const costPriceHelper = {
  formatCost,
  getCost,
  getFormattedCost,
  getSticker,
  getFormattedStickerPrice,
  getLabel,
}

export default costPriceHelper
